import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);

  return (
    <div className="grain min-h-screen relative">
      <Navbar />
      <main data-testid="page-main" className="pt-[72px] relative z-10">{children}</main>
      <Footer />
    </div>
  );
}
